import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListLocationCityCell } from './charge-point-list-location-city.cell';
import { ChargePointListLocationCityHeader } from './charge-point-list-location-city.header';

export const ChargePointListLocationCityColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['location']
> = {
  id: 'locationCity',
  enableSorting: false,
  header: ChargePointListLocationCityHeader,
  cell: ChargePointListLocationCityCell,
  meta: { maxWidth: '140px' },
};
